












































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { ExtendedTrade } from '@/models/trade';
import type { AppliedLesson } from '@/models/appliedlesson';
import moment from 'moment';
import MobileDetect from 'mobile-detect';
import type { ProjectUser } from '@/models/projectUser';
import type { User } from '@/models/user';
import type { Project } from '@/models/project';
import type { CompanySetting } from '@/models/companySetting';
import type { DynamicField } from '@/models/dynamicField';
import { appliedLessonWebservice } from '@/webservices/appliedlesson';
import { WorksheetColumns } from '@/components/prine/enums/WorksheetColumns';
import MoreInfoModal from '@/components/MoreInfoModal.vue';
import FormProjectUserPicker from '@/components/form/FormProjectUserPicker.vue';

@Component({
    name: 'DetailedTrade',
    components: {
        MoreInfoModal,
        FormProjectUserPicker,
    },
})
export default class DetailedTrade extends Vue {
    private moreInfoShowModalActive: boolean = false;
    private moreInfoModalInsight: string;
    private moreInfoModalContent: string;
    private moreInfoModalId: number;

    @Prop() private trade: ExtendedTrade;
    @Prop() private defaultOpenedDetails: number[];

    private minDate: Date = moment('2010-01-01').toDate();
    private maxDate: Date = moment('2040-12-31').toDate();
    @Getter('project/selectedProject') private selectedProject: Project;
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('company/dynamicFields') private dynamicFields: DynamicField[];
    @Getter('utils/currentLocale') private currentLocale: string;

    @Prop() private tableColumns;
    private updateKey: number = 1;

    private initializeMoreInfoModal(content: string, insight: string, id: number) {
        this.moreInfoModalContent = content;
        this.moreInfoModalInsight = insight;
        this.moreInfoModalId = id;
        this.moreInfoShowModalActive = true;
    }

    get selectedWorksheetColumns() {
        return this.$store.getters['worksheet/selectedWorksheetColumns'] as WorksheetColumns[];
    }

    set selectedWorksheetColumns(value) {
        this.$store.commit('worksheet/setSelectedWorksheetColumns', value);
    }

    private updateAppliedLesson(appliedLesson: AppliedLesson) {
        appliedLessonWebservice.update(appliedLesson);
        this.updateSnackbarNotification();
        this.updateKey++;
    }

    private checkedByUser(user: User | null) {
        if (user) {
            return user.firstname + ' ' + user.lastname;
        } else {
            return '-';
        }
    }

    private get isDesktop() {
        const isNotDesktop = window.matchMedia('only screen and (max-width: 1300px)').matches;
        const md = new MobileDetect(window.navigator.userAgent);
        return !(md.mobile() || md.phone() || md.tablet() || isNotDesktop);
    }

    private get allProjectUsers() {
        const projectUsers: ProjectUser[] = [];
        this.selectedProject.users.forEach((user, index) => {
            const temp: ProjectUser = {
                unique_identifier: Math.floor(Math.random() * 100000 + 1),
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.email,
                user_id: user.id,
                isExternalUser: false,
            };
            projectUsers.push(temp);
        });
        this.selectedProject.external_users.forEach((user, index) => {
            const temp: ProjectUser = {
                unique_identifier: Math.floor(Math.random() * 100000 + 1),
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.email,
                user_id: user.id,
                isExternalUser: true,
            };
            projectUsers.push(temp);
        });

        return projectUsers;
    }

    private fullname({ firstname, lastname }) {
        return `${firstname} ${lastname}`;
    }

    private dynamicFieldValue({ title }) {
        return `${title}`;
    }

    private updateSnackbarNotification() {
        this.$buefy.snackbar.open({
            message: 'Updated',
            type: 'is-success',
            position: 'is-bottom-right',
            actionText: 'OK',
            indefinite: false,
            queue: false,
            duration: 1500,
        });
    }

    private detailedRowsTransitionName() {
        return 'slide-fade';
    }
}
